// Third-party
import React from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
  message?: string;
};
const LoadingSpinner = ({ message, className }: Props) => (
  <div className={classNames(className, 'loading-spinner')} data-testid="loading-spinner">
    <i className="icon-spinner" />
    {message && <span>{message}</span>}
  </div>
);

export default LoadingSpinner;
